
jQuery(document).ready(function( $ ){



	// END JQUERY
});
